import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import FeaturedIn from "@/components/FeaturedIn";
import About from "@/components/About";
import Mission from "@/components/Mission";
import Impact from "@/components/Impact";
import Ventures from "@/components/Ventures";
import Services from "@/components/Services";
import Awards from "@/components/Awards";
import Locations from "@/components/Locations";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import GrainOverlay from "@/components/GrainOverlay";
import ScrollProgress from "@/components/ScrollProgress";

const Home = () => {
    return (
        <main data-testid="home-page" className="relative bg-paper-50 text-ink-900 min-h-screen overflow-x-hidden">
            <GrainOverlay />
            <ScrollProgress />
            <Navbar />
            <Hero />
            <FeaturedIn />
            <About />
            <Mission />
            <Impact />
            <Ventures />
            <Services />
            <Awards />
            <Locations />
            <Gallery />
            <Contact />
            <Footer />
        </main>
    );
};

export default Home;
